import React from "react";
import { TokenHandler } from "../components/Auth/TokenHandler/TokenHandler";

function TokenHandlerPage() {
  return <TokenHandler />;
}

export default TokenHandlerPage;
